module.exports = "<mdb-select #select [options]=\"selectOptions\" (selected)=\"selectUser($event)\" \n    placeholder=\"Choose a user\" class=\"colorful-select dropdown-primary\">\n</mdb-select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user-selector/user-selector.component.html
// module id = ./src/app/shared/user-selector/user-selector.component.html
// module chunks = main